<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19O6toP/image/Cover3.jpg?1721600811933" alt="This image is the cover for the book Desse's Big Day"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Desse's Big Day
      </h1>
      <p class="bookDescription body article font2">
        <p>It’s Desse the Draggo Raptor’s first day of school. He’s scared and nervous, will the other dragons be cruel? Desse is different in more ways than one, He’s worried this might stop him from having fun. Will Desse be able to breathe fire and fly? All he’s ever wanted is to fly sky-high. Or will he shed a tear and feel self-doubt? Spread your wings and start reading to find out!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amanda Duffy, Nadica Mitevska
      </h2>
      
      <p class="authorDescription body article">Amanda has been in education for over 30 years, teaching in Japan, Tokyo, Shanghai, Hong Kong, Singapore and now Ireland. Throughout all the changes that a transient lifestyle presents, she has built a career based on her passion for supporting young children with additional needs. Amanda’s first book is set where she resides and works now, within a quaint village Primary School in beautiful rural farmland in County Mayo, Ireland. It is the people, animals and affinity for the natural elements that surround her which inspired her to write Desse’s Big Day. In particular, she identifies with the vulnerability of children starting school and wanted to dedicate a book to them where being different is celebrated. Amanda has an Arts Degree from Winchester School of Art and has always tried to bring a creative flair to both her occupational and private life. She lives with her husband John, daughter Lizzy, and a spoilt cat named Pandora, who loves to eat very strong mature cheese. Amanda hopes to write about Pandora as the star of future publications!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7de8e4fe